import { userService } from '../../application/UserService';
import { useRetrieveActiveProject } from '../project/useRetrieveActiveProject';

export const useGetMapDefaults = () => {
  const { data: activeProject } = useRetrieveActiveProject();

  const getZoom = (): number | undefined => {
    const userLocationCountry = userService.getUserLocationByCountry();
    return userLocationCountry?.mapZoomLevel ?? undefined;
  };

  const getCoordinates = (): { lat: number; lng: number } | undefined => {
    if (activeProject?.location?.lat && activeProject?.location?.lng) {
      return {
        lat: activeProject?.location?.lat,
        lng: activeProject?.location?.lng,
      };
    }

    const userLocationCountry = userService.getUserLocationByCountry();
    if (userLocationCountry?.latitude && userLocationCountry?.longitude) {
      return { lat: userLocationCountry.latitude, lng: userLocationCountry.longitude };
    }
    return undefined;
  };

  return {
    getZoom,
    getCoordinates,
  };
};
